export default "__VITE_ASSET__ClY6brbc__"